<div
  *ngIf="formConfig.label"
  [class.re-inline-label]="formConfig.inlineLabel"
  [class.re-label-hint]="formConfig.labelHint">
  <label class="form-label" [class.re-disabled]="disabled" [for]="formConfig.id"
    >{{ formConfig.label }}<i *ngIf="formConfig.mandatory" class="fa-solid fa-asterisk"></i
  ></label>
  <div *ngIf="formConfig.labelHint" [id]="hintId()">{{ formConfig.labelHint }}</div>
</div>
